import styled from 'styled-components';
import { onPhone } from '../theme/tokens';

// Agent Zero design tokens (matches agent-admin-platform / agent-frontend).
export const AZ = {
  navyGrad: 'linear-gradient(135deg, #0b1426 0%, #152642 50%, #1e3a5f 100%)',
  wordmarkGrad: 'linear-gradient(135deg, #0b1426 0%, #1a2332 50%, #2c3e50 100%)',
  avatarGrad: 'linear-gradient(135deg, #0b1426 0%, #1a2332 100%)',
  ink: '#2c3e50',
  soft: '#8c8c8c',
  pageBg: '#f5f5f5',
  border: '#F0F0F0'
};

export const Shell = styled.div`
  height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .ant-layout {
    background: ${AZ.pageBg};
    flex: 1;
    min-height: 0;
  }
  .app-sider {
    background: #fff !important;
    border-right: 1px solid ${AZ.border};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    z-index: 2;
    height: 100%;
    overflow: hidden;
  }
  .ant-layout-sider-children {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .app-main {
    height: 100%;
    min-width: 0;
  }
  .app-content:has(> [data-fill]) {
    display: flex;
    flex-direction: column;
  }
  [data-fill] {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const PreviewBar = styled.div`
  flex: none;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 16px;
  color: #fff;
  background: ${AZ.navyGrad};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  font-size: 13px;

  .pb-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }
  .pb-label .pb-org {
    font-weight: 400;
    color: rgba(255, 255, 255, 0.72);
  }
  .pb-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
  .pb-actions .pb-as {
    color: rgba(255, 255, 255, 0.72);
  }
  ${onPhone} {
    .pb-actions {
      margin-left: 0;
      width: 100%;
    }
  }
`;

export const Brand = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 16px 16px 10px;

  img {
    width: 30px;
    height: 30px;
  }
  .br-name {
    font-weight: 700;
    font-size: 16px;
    background: ${AZ.navyGrad};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .br-env {
    font-size: 12px;
    color: #595959;
    line-height: 1.3;
  }
  .br-close {
    flex: none;
    width: 40px;
    height: 40px;
    margin: -6px -10px 0 auto;
    border: 0;
    border-radius: 8px;
    background: none;
    color: #262626;
    font-size: 18px;
    cursor: pointer;
  }
  ${onPhone} {
    padding: 0;
    .br-close {
      width: 44px;
      height: 44px;
      margin: 0 0 0 auto;
      background: rgba(21, 38, 66, 0.08);
    }
  }
`;

export const NavList = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  flex: 1;
  overflow: auto;

  .nav-div {
    height: 1px;
    background: ${AZ.border};
    margin: 8px 6px;
    flex: none;
  }
  ${onPhone} {
    padding: 0;
  }
`;

export const NavItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  color: #595959;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  width: 100%;
  flex: none;

  svg {
    width: 18px;
  }
  .nav-label {
    flex: 1;
    min-width: 0;
  }
  &:hover {
    background: ${AZ.border};
    color: #262626;
  }
  &[aria-current='page'] {
    background: var(--brand-grad, ${AZ.navyGrad});
    color: #fff;
  }
  &[aria-current='page'] span[data-count] {
    background: #fff;
    color: var(--brand-primary);
  }
`;

export const NavCount = styled.span.attrs({ 'data-count': true })`
  background: ${(p) => (p.$gray ? '#595959' : '#A8071A')};
  color: #fff;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  padding: 1px 7px;
  min-width: 20px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  ${onPhone} {
    font-size: 12px;
  }
`;

export const Header = styled.header`
  position: relative;
  height: 64px;
  flex: none;
  background: #fff;
  border-bottom: 1px solid ${AZ.border};
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;

  .hd-crumb {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #262626;
  }
  .hd-org {
    font-size: 12.5px;
    color: #595959;
  }
  .hd-crumb b {
    font-weight: 600;
  }
  .hd-menu {
    flex: none;
    width: 40px;
    height: 40px;
    margin-left: -10px;
    border: 0;
    border-radius: 8px;
    background: none;
    color: #262626;
    font-size: 18px;
    cursor: pointer;
  }
  ${onPhone} {
    height: 48px;
    gap: 8px;
    padding: 0 10px;
    .hd-org {
      display: none;
    }
    .hd-crumb b {
      font-size: 15px;
      font-weight: 700;
    }
    .hd-menu {
      width: 36px;
      height: 36px;
      margin: 0;
      background: rgba(21, 38, 66, 0.08);
      font-size: 14px;
    }
  }
`;

export const TabBar = styled.nav`
  flex: none;
  display: flex;
  background: #fff;
  border-top: 1px solid ${AZ.border};
  padding-bottom: max(16px, env(safe-area-inset-bottom));

  button {
    flex: 1;
    min-width: 0;
    height: 59px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    border: 0;
    background: none;
    font: inherit;
    font-size: 10.5px;
    font-weight: 600;
    color: #595959;
    white-space: nowrap;
    cursor: pointer;
  }
  .tb-ic {
    font-size: 17px;
    line-height: 1;
    padding: 4px 12px;
    border-radius: 999px;
  }
  button[aria-current='page'] {
    color: var(--brand-primary);
  }
  button[aria-current='page'] .tb-ic {
    background: var(--brand-grad, ${AZ.navyGrad});
    color: #fff;
  }
  span[data-count] {
    position: absolute;
    top: 2px;
    right: 8px;
    font-size: 11px;
  }
`;

export const StatusChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 18px;
  color: ${(p) => (p.$on ? '#237804' : '#3F4652')};
  background: ${(p) => (p.$on ? '#F6FFED' : '#EEF0F3')};

  svg {
    font-size: 11px;
  }
  ${onPhone} {
    align-self: flex-start;
  }
`;

export const SideFoot = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid ${AZ.border};
  ${onPhone} {
    padding: 10px 0 0;
  }

  .sf-user {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    border: 0;
    background: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    width: 100%;
  }
  .sf-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${AZ.navyGrad};
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex: none;
  }
  .sf-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

// Header block shown at the top of the identity dropdown menu.
export const MenuIdentity = styled.div`
  padding: 4px 4px 8px;
  .mi-name {
    font-size: 14px;
    font-weight: 600;
    color: ${AZ.ink};
  }
  .mi-email {
    font-size: 12px;
    color: ${AZ.soft};
  }
`;
